module.exports = function () {
    const infoPopup = document.querySelector('.holding-info-popup')
    const toggleInfoPopupBtn = document.querySelector('.toggle-info-popup')
    const closeInfoPopupBtn = document.querySelector('.holding-info-popup__close');
    const infoPopupContent = document.querySelector('.holding-info-popup__content')
    function toggleInfoPopup() {
        infoPopup.classList.toggle('active')
    }
    if(toggleInfoPopupBtn && closeInfoPopupBtn) {
        toggleInfoPopupBtn.addEventListener('click', toggleInfoPopup)
        closeInfoPopupBtn.addEventListener('click', toggleInfoPopup)
    }
};